import { render } from "./MovieMain.vue?vue&type=template&id=0a3c7d71"
import script from "./MovieMain.vue?vue&type=script&lang=js"
export * from "./MovieMain.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__